var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "200px", "margin-right": "10px" },
              attrs: { placeholder: "Trigger Type", clearable: "" },
              on: { change: _vm.getList },
              model: {
                value: _vm.listQuery.triggerType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "triggerType", $$v)
                },
                expression: "listQuery.triggerType",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Registration", value: "registration" },
              }),
              _c("el-option", {
                attrs: { label: "Referral", value: "referral" },
              }),
              _c("el-option", {
                attrs: {
                  label: "Device Activation",
                  value: "device_activation",
                },
              }),
              _c("el-option", {
                attrs: { label: "Promo Code", value: "promo_code" },
              }),
              _c("el-option", {
                attrs: {
                  label: "Subscription Cancel",
                  value: "subscription_cancel",
                },
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "150px", "margin-right": "10px" },
              attrs: { placeholder: "Status", clearable: "" },
              on: { change: _vm.getList },
              model: {
                value: _vm.listQuery.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isActive", $$v)
                },
                expression: "listQuery.isActive",
              },
            },
            [
              _c("el-option", { attrs: { label: "Active", value: "true" } }),
              _c("el-option", { attrs: { label: "Inactive", value: "false" } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" New Campaign ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.id))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Campaign Key", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { size: "small" } }, [
                      _vm._v(_vm._s(row.campaignKey)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Name", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.name))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trigger", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getTriggerTagType(row.triggerType),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatTriggerType(row.triggerType)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Features", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.campaignFeatures && row.campaignFeatures.length
                      ? _c(
                          "div",
                          _vm._l(row.campaignFeatures, function (cf) {
                            return _c(
                              "el-tag",
                              {
                                key: cf.id,
                                staticStyle: {
                                  "margin-right": "5px",
                                  "margin-bottom": "3px",
                                },
                                attrs: { size: "mini", type: "info" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      cf.feature
                                        ? cf.feature.name
                                        : cf.featureId
                                    ) +
                                    " (" +
                                    _vm._s(
                                      _vm.formatCampaignFeatureDuration(cf)
                                    ) +
                                    ") "
                                ),
                              ]
                            )
                          }),
                          1
                        )
                      : _c("span", { staticStyle: { color: "#999" } }, [
                          _vm._v("No features"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Usage", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", [_vm._v(_vm._s(row.currentUses || 0))]),
                    row.maxUses
                      ? _c("span", [_vm._v(" / " + _vm._s(row.maxUses))])
                      : _c("span", [_vm._v(" / ∞")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Period", width: "180", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.startsAt || row.endsAt
                      ? _c("div", [
                          row.startsAt
                            ? _c(
                                "div",
                                { staticStyle: { "font-size": "11px" } },
                                [
                                  _vm._v(
                                    " From: " +
                                      _vm._s(_vm.formatDate(row.startsAt)) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          row.endsAt
                            ? _c(
                                "div",
                                { staticStyle: { "font-size": "11px" } },
                                [
                                  _vm._v(
                                    " To: " +
                                      _vm._s(_vm.formatDate(row.endsAt)) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _c("span", { staticStyle: { color: "#999" } }, [
                          _vm._v("Always"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.isActive,
                        callback: function ($$v) {
                          _vm.$set(row, "isActive", $$v)
                        },
                        expression: "row.isActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              width: "200",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "info",
                          icon: "el-icon-tickets",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewGrants(row)
                          },
                        },
                      },
                      [_vm._v(" Grants ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogStatus === "create"
                ? "Create Campaign"
                : "Edit Campaign",
            visible: _vm.dialogFormVisible,
            width: "700px",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Campaign Key", prop: "campaignKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., free_trial_30days",
                      disabled: _vm.dialogStatus === "update",
                    },
                    model: {
                      value: _vm.formData.campaignKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "campaignKey", $$v)
                      },
                      expression: "formData.campaignKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Campaign name" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Campaign description",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trigger Type", prop: "triggerType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.onTriggerTypeChange },
                      model: {
                        value: _vm.formData.triggerType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "triggerType", $$v)
                        },
                        expression: "formData.triggerType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "Registration (on signup)",
                          value: "registration",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Referral (when referred)",
                          value: "referral",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Device Activation (connect device)",
                          value: "device_activation",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Promo Code (manual redemption)",
                          value: "promo_code",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Subscription Cancel (retention)",
                          value: "subscription_cancel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.triggerType === "promo_code"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Promo Code", prop: "promoCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "e.g., WELCOME2024" },
                        model: {
                          value: _vm.formData.promoCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "promoCode", $$v)
                          },
                          expression: "formData.promoCode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.triggerType === "device_activation"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Device Type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "Any device" },
                          model: {
                            value: _vm.formData.deviceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "deviceType", $$v)
                            },
                            expression: "formData.deviceType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Any Device", value: "" },
                          }),
                          _c("el-option", {
                            attrs: { label: "V1 Only", value: "V1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "V2 Only", value: "V2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Features"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Features", prop: "features" } },
                [
                  _c("div", { staticClass: "campaign-features-help" }, [
                    _vm._v(" " + _vm._s(_vm.$t("campaigns.featuresHelpIntro"))),
                    _c("br"),
                    _vm._v(" • "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("campaigns.durationDaysLabel"))),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("campaigns.durationDaysHelp"))),
                    _c("br"),
                    _vm._v(" • "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("campaigns.fixedDateLabel"))),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("campaigns.fixedDateHelp")) + " "
                    ),
                  ]),
                  _c(
                    "el-row",
                    {
                      staticClass: "campaign-features-headers",
                      attrs: { gutter: 10 },
                    },
                    [
                      _c("el-col", { attrs: { span: 9 } }, [
                        _c("span", { staticClass: "col-label" }, [
                          _vm._v("Feature"),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "col-label" }, [
                          _vm._v(_vm._s(_vm.$t("campaigns.colDurationType"))),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 9 } }, [
                        _c("span", { staticClass: "col-label" }, [
                          _vm._v(_vm._s(_vm.$t("campaigns.colValue"))),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 2 } }),
                    ],
                    1
                  ),
                  _vm._l(_vm.formData.features, function (feature, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "el-row",
                          {
                            attrs: {
                              gutter: 10,
                              type: "flex",
                              align: "middle",
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "campaigns.selectFeature"
                                      ),
                                    },
                                    model: {
                                      value: feature.featureId,
                                      callback: function ($$v) {
                                        _vm.$set(feature, "featureId", $$v)
                                      },
                                      expression: "feature.featureId",
                                    },
                                  },
                                  _vm._l(_vm.availableFeatures, function (f) {
                                    return _c("el-option", {
                                      key: f.id,
                                      attrs: { label: f.name, value: f.id },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onDurationModeChange(feature)
                                      },
                                    },
                                    model: {
                                      value: feature.durationMode,
                                      callback: function ($$v) {
                                        _vm.$set(feature, "durationMode", $$v)
                                      },
                                      expression: "feature.durationMode",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("campaigns.modeDays"),
                                        value: "days",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("campaigns.modeDate"),
                                        value: "date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                feature.durationMode === "days"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "6px",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            min: 1,
                                            max: 3650,
                                            placeholder: _vm.$t(
                                              "campaigns.daysExample"
                                            ),
                                          },
                                          model: {
                                            value: feature.durationDays,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                feature,
                                                "durationDays",
                                                $$v
                                              )
                                            },
                                            expression: "feature.durationDays",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#606266",
                                              "font-size": "13px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("campaigns.daysUnit")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "datetime",
                                        placeholder:
                                          _vm.$t("campaigns.endDate"),
                                      },
                                      model: {
                                        value: feature.fixedEndDate,
                                        callback: function ($$v) {
                                          _vm.$set(feature, "fixedEndDate", $$v)
                                        },
                                        expression: "feature.fixedEndDate",
                                      },
                                    }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 2 } },
                              [
                                _c("el-button", {
                                  attrs: {
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    circle: "",
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFeature(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-plus" },
                      on: { click: _vm.addFeature },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("campaigns.addFeature")) + " ")]
                  ),
                ],
                2
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Limits"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Max Total Uses" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 0, placeholder: "Unlimited" },
                    model: {
                      value: _vm.formData.maxUses,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "maxUses", $$v)
                      },
                      expression: "formData.maxUses",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#999",
                        "margin-left": "10px",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("0 = unlimited")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Max Per User" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 1, max: 100 },
                    model: {
                      value: _vm.formData.maxUsesPerUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "maxUsesPerUser", $$v)
                      },
                      expression: "formData.maxUsesPerUser",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Validity Period"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Start Date" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "Campaign start date",
                    },
                    model: {
                      value: _vm.formData.startsAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "startsAt", $$v)
                      },
                      expression: "formData.startsAt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "End Date" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "Campaign end date",
                    },
                    model: {
                      value: _vm.formData.endsAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "endsAt", $$v)
                      },
                      expression: "formData.endsAt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dialogStatus === "create" ? "Create" : "Save"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "Campaign Grants - " +
              (_vm.selectedCampaign ? _vm.selectedCampaign.name : ""),
            visible: _vm.grantsDialogVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.grantsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.showGrantUserDialog },
                },
                [_vm._v(" Grant to User ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.grantsLoading,
                  expression: "grantsLoading",
                },
              ],
              attrs: { data: _vm.grants, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "ID", width: "70", prop: "id" },
              }),
              _c("el-table-column", {
                attrs: { label: "User ID", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-family": "monospace",
                              "font-size": "11px",
                            },
                          },
                          [_vm._v(_vm._s(row.userId))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Granted At", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.formatDate(row.grantedAt)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Granted By", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.grantedBy || "System"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Source", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.sourceReference || "-"))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.grantsTotal > 0,
                expression: "grantsTotal > 0",
              },
            ],
            attrs: {
              total: _vm.grantsTotal,
              page: _vm.grantsQuery.page,
              limit: _vm.grantsQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.grantsQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.grantsQuery, "limit", $event)
              },
              pagination: _vm.loadGrants,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Grant Campaign to User",
            visible: _vm.grantUserDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.grantUserDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "grantForm",
              attrs: { model: _vm.grantFormData, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "User ID", prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Enter user ID" },
                    model: {
                      value: _vm.grantFormData.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.grantFormData, "userId", $$v)
                      },
                      expression: "grantFormData.userId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.grantUserDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.grantLoading },
                  on: { click: _vm.grantToUser },
                },
                [_vm._v(" Grant ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }